module.exports = __webpack_public_path__ + "assets/img/driver-btn-4d32e659.png";